module.exports = __webpack_public_path__ + "img/mege-m.79ec741.svg";